export const groupProgramBook = (data: any): any => {
    const { ...dataRes } = data;
    const categories = (dataRes.values || []).map((itSection: any, n: number) => {
        const dataSection: any = {
            id: itSection?.id ? itSection.id : '',
            sortOrder: itSection?.sortOrder ? itSection.sortOrder : 0,
            title: itSection?.title ? itSection.title : '',
            description: itSection?.description ? itSection.description : '',
            order: n,
            status: itSection.status ? itSection.status : 1,
            isHidden: itSection?.isHidden ? itSection.isHidden : false,
            values: [],
            targets: [],
        };
        dataSection.values = (itSection.values || []).map((itDomain: any) => {
            const dataDomain = {
                id: itDomain?.id ? itDomain.id : '',
                sortOrder: itDomain?.sortOrder ? itDomain.sortOrder : 0,
                title: itDomain?.title ? itDomain.title : '',
                description: itDomain?.description ? itDomain.description : '',
                order: n,
                status: itDomain.status ? itDomain.status : 1,
                isHidden: itDomain?.isHidden ? itDomain.isHidden : false,
                values: [],
            };
            dataDomain.values = (itDomain.values || []).map((itLongTerm: any) => {
                const dataLongTerm = {
                    id: itLongTerm?.id ? itLongTerm.id : '',
                    sortOrder: itLongTerm?.sortOrder ? itLongTerm.sortOrder : 0,
                    title: itLongTerm?.title ? itLongTerm.title : '',
                    description: itLongTerm?.description ? itLongTerm.description : '',
                    order: n,
                    status: itLongTerm.status ? itLongTerm.status : 1,
                    isHidden: itLongTerm?.isHidden ? itLongTerm.isHidden : false,
                    values: [],
                };
                dataLongTerm.values = (itLongTerm.values || []).map((itShortTerm: any) => {
                    const dataShortTerm = {
                        id: itShortTerm?.id ? itShortTerm.id : '',
                        sortOrder: itShortTerm?.sortOrder ? itShortTerm.sortOrder : 0,
                        title: itShortTerm?.title ? itShortTerm.title : '',
                        description: itShortTerm?.description ? itShortTerm.description : '',
                        order: n,
                        status: itShortTerm.status ? itShortTerm.status : 1,
                        isHidden: itShortTerm?.isHidden ? itShortTerm.isHidden : false,
                        targets: [],
                    };
                    dataShortTerm.targets = (itShortTerm.targets || []).map((itTarget: any) => {
                        const dataTarget = {
                            title: itTarget?.title ? itTarget.title : '',
                            sortOrder: itTarget?.sortOrder ? itTarget.sortOrder : 0,
                            prompt: itTarget?.prompt?.value
                                ? itTarget.prompt.value
                                : itTarget.prompt
                                ? itTarget.prompt
                                : 10,
                            minAttempts: itTarget?.minAttempts ? itTarget.minAttempts : 1,
                            masterValue: itTarget?.masterValue ? itTarget.masterValue : '',
                            masteryDirection: itTarget?.masteryDirection?.value
                                ? itTarget.masteryDirection.value
                                : itTarget.masteryDirection
                                ? itTarget.masteryDirection
                                : 1,
                            isHidden: itTarget?.isHidden ? itTarget.isHidden : false,
                            isPhased: itTarget?.isPhased ? itTarget.isPhased : false,
                            masterNumberOfSeance: itTarget?.masterNumberOfSeance ? itTarget.masterNumberOfSeance : '',
                            description: itTarget?.description ? itTarget.description : '',
                            type: itTarget?.type?.value ? itTarget.type.value : itTarget.type ? itTarget.type : 1,
                            order: n,
                            status: itTarget.status ? itTarget.status : 1,
                            id: itTarget?.id ? itTarget.id : '',
                            options: [],
                            prompts: [],
                            phases: [],
                            hasPrompt: false,
                        };
                        if (itTarget.programTargetOptions) {
                            dataTarget.options = itTarget.programTargetOptions.map((itOption: any) => {
                                const dataOption = {
                                    title: itOption?.title ? itOption.title : '',
                                    prompt: itOption?.prompt?.value
                                        ? itOption.prompt.value
                                        : itOption.prompt
                                        ? itOption.prompt
                                        : 10,
                                    description: itOption?.description ? itOption.description : '',
                                    order: n,
                                    status: itOption.status ? itOption.status : 1,
                                    id: itOption?.id ? itOption.id : '',
                                };
                                return dataOption;
                            });
                        }

                        if (itTarget.programTargetPhases) {
                            dataTarget.phases = itTarget.programTargetPhases
                                .map((itPhase: any) => {
                                    if (itPhase?.id || (itPhase?.startDate && itPhase?.title)) {
                                        const dataPhase = {
                                            id: itPhase?.id ? itPhase.id : '',
                                            title: itPhase?.title
                                                ? itPhase.title
                                                : dataTarget.title
                                                ? dataTarget.title
                                                : '',
                                            prompt: itPhase?.prompt?.value
                                                ? itPhase.prompt.value
                                                : itPhase.prompt
                                                ? itPhase.prompt
                                                : 10,
                                            startDate: itPhase?.startDate ? itPhase.startDate : '',
                                            minAttempts: itPhase?.minAttempts ? itPhase.minAttempts : 1,
                                            masterValue: itPhase?.masterValue ? itPhase.masterValue : '',
                                            masteryDirection: itPhase?.masteryDirection?.value
                                                ? itPhase.masteryDirection.value
                                                : itPhase.masteryDirection
                                                ? itPhase.masteryDirection
                                                : 1,
                                            masterNumberOfSeance: itPhase?.masterNumberOfSeance
                                                ? itPhase.masterNumberOfSeance
                                                : '',
                                            isComplete: itPhase?.isComplete ? itPhase.isComplete : false,
                                            status: 1,
                                            options: [],
                                        };
                                        if (itPhase.programTargetPhaseOptions) {
                                            dataPhase.options = itPhase.programTargetPhaseOptions.map(
                                                (itPhaseOption: any) => {
                                                    const dataPhaseOption = {
                                                        title: itPhaseOption?.title ? itPhaseOption.title : '',
                                                        prompt: itPhaseOption?.prompt?.value
                                                            ? itPhaseOption.prompt.value
                                                            : itPhaseOption.prompt
                                                            ? itPhaseOption.prompt
                                                            : 10,
                                                        description: itPhaseOption?.description
                                                            ? itPhaseOption.description
                                                            : '',
                                                        order: n,
                                                        status: itPhaseOption.status ? itPhaseOption.status : 1,
                                                        id: itPhaseOption?.id ? itPhaseOption.id : '',
                                                    };
                                                    return dataPhaseOption;
                                                },
                                            );
                                        }
                                        return dataPhase;
                                    }
                                    return null;
                                })
                                .filter(Boolean);
                        }

                        if (itTarget.programTargetPrompts) {
                            dataTarget.prompts = itTarget.programTargetPrompts.map((itPrompt: any) => {
                                if (itPrompt.checked) {
                                    const dataPrompt = {
                                        prompt: itPrompt?.prompt ? itPrompt.prompt : '',
                                        description: itPrompt?.description ? itPrompt.description : '',
                                        order: n,
                                        status: 1,
                                        id: itPrompt?.id ? itPrompt.id : '',
                                    };
                                    return dataPrompt;
                                } else {
                                    const dataPrompt = {
                                        prompt: itPrompt?.prompt ? itPrompt.prompt : '',
                                        description: itPrompt?.description ? itPrompt.description : '',
                                        order: n,
                                        status: 2,
                                        id: itPrompt?.id ? itPrompt.id : '',
                                    };
                                    return dataPrompt;
                                }
                            });
                        }
                        return dataTarget;
                    });
                    return dataShortTerm;
                });

                return dataLongTerm;
            });
            return dataDomain;
        });
        return dataSection;
    });

    return {
        /*student: {
            id: dataRes.studentId,
        },*/
        student: dataRes.studentId,
        //order: dataRes.orderId,
        categories,
        programMainCategories: categories,
        /*student: {
            firstName: 'string',
            lastName: 'string',
        },*/
    };
};
